import { render, staticRenderFns } from "./BlogManagement.vue?vue&type=template&id=64a144c4&scoped=true"
import script from "./BlogManagement.vue?vue&type=script&lang=js"
export * from "./BlogManagement.vue?vue&type=script&lang=js"
import style0 from "./BlogManagement.vue?vue&type=style&index=0&id=64a144c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a144c4",
  null
  
)

export default component.exports